import React from 'react'
import { ProductQtyInput } from '../ProductQtyInput'
import { MagentoProductPrices } from 'lib/types'

interface Props {
  qty: number
  handleQtyChange: (qty: any) => void
  packageType?: string
  packageQty?: string
  price: MagentoProductPrices
  productId: number
  frequency: number
  subtotalPrice: number
  onReturnToSubscriptions?: () => void
  showReturnToSubscription?: boolean
}

export const OneTime: React.FC<Props> = ({
  qty,
  handleQtyChange,
  packageType,
  packageQty,
  price,
  productId,
  frequency,
  subtotalPrice,
  onReturnToSubscriptions,
  showReturnToSubscription = false
}) => {
  return (
    <>
      <div
        title='One-Time Purchase'
      >
        <ProductQtyInput
          qty={qty}
          handleQtyChange={handleQtyChange}
          packageType={packageType}
          packageQty={packageQty}
          price={price}
          productId={productId}
          frequency={frequency}
          subtotalPrice={subtotalPrice}
        />
      </div>
      {showReturnToSubscription && (
        <button className='return-subscriptions' onClick={onReturnToSubscriptions}>Save 10% on every order by choosing Schedule & Save!</button>
      )}
    </>
  )
}
